import type { Technology } from '../types/project';

export const TECHNOLOGIES: Record<string, Technology> = {
  // Frontend Frameworks & Libraries
  REACT: {
    name: 'React',
    colorClass: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  },
  NEXT_JS: {
    name: 'Next.js',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },
  VUE: {
    name: 'Vue.js',
    colorClass:
      'bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-100',
  },
  NUXT: {
    name: 'Nuxt.js',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  ANGULAR: {
    name: 'Angular',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },
  SVELTE: {
    name: 'Svelte',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  REMIX: {
    name: 'Remix',
    colorClass:
      'bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-100',
  },

  // Styling & UI
  TAILWIND: {
    name: 'Tailwind CSS',
    colorClass: 'bg-sky-100 dark:bg-sky-900 text-sky-800 dark:text-sky-100',
  },
  MATERIAL_UI: {
    name: 'Material UI',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  CHAKRA_UI: {
    name: 'Chakra UI',
    colorClass: 'bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-100',
  },
  STYLED_COMPONENTS: {
    name: 'Styled Components',
    colorClass: 'bg-pink-100 dark:bg-pink-900 text-pink-800 dark:text-pink-100',
  },
  SASS: {
    name: 'Sass',
    colorClass: 'bg-rose-100 dark:bg-rose-900 text-rose-800 dark:text-rose-100',
  },
  FRAMER_MOTION: {
    name: 'Framer Motion',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },

  // Web Development Tools & Build Systems
  TYPESCRIPT: {
    name: 'TypeScript',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  WEBPACK: {
    name: 'Webpack',
    colorClass: 'bg-sky-100 dark:bg-sky-900 text-sky-800 dark:text-sky-100',
  },
  VITE: {
    name: 'Vite',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  BABEL: {
    name: 'Babel',
    colorClass:
      'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100',
  },
  ESLINT: {
    name: 'ESLint',
    colorClass:
      'bg-violet-100 dark:bg-violet-900 text-violet-800 dark:text-violet-100',
  },
  ENV: {
    name: '.env',
    colorClass: 'bg-lime-100 dark:bg-lime-900 text-lime-800 dark:text-lime-100',
  },
  PRETTIER: {
    name: 'Prettier',
    colorClass: 'bg-pink-100 dark:bg-pink-900 text-pink-800 dark:text-pink-100',
  },
  GIT: {
    name: 'Git',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  GITHUB: {
    name: 'GitHub',
    colorClass:
      'bg-slate-100 dark:bg-slate-900 text-slate-800 dark:text-slate-100',
  },

  // Web3 & Blockchain
  ETHEREUM: {
    name: 'Ethereum',
    colorClass:
      'bg-slate-100 dark:bg-slate-900 text-slate-800 dark:text-slate-100',
  },
  SOLIDITY: {
    name: 'Solidity',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },
  WEB3_JS: {
    name: 'Web3.js',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },

  // JAMstack & Headless CMS
  GATSBY: {
    name: 'Gatsby',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  STRAPI: {
    name: 'Strapi',
    colorClass:
      'bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-100',
  },
  CONTENTFUL: {
    name: 'Contentful',
    colorClass: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  },

  // Web Performance & SEO
  LIGHTHOUSE: {
    name: 'Lighthouse',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },
  NEXT_SEO: {
    name: 'Next SEO',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },

  // Serverless & Edge Computing
  VERCEL: {
    name: 'Vercel',
    colorClass:
      'bg-slate-100 dark:bg-slate-900 text-slate-800 dark:text-slate-100',
  },
  NETLIFY: {
    name: 'Netlify',
    colorClass: 'bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-100',
  },
  AWS_LAMBDA: {
    name: 'AWS Lambda',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  CLOUDFLARE: {
    name: 'Cloudflare',
    colorClass:
      'bg-amber-100 dark:bg-amber-900 text-amber-800 dark:text-amber-100',
  },

  // API & Data Fetching
  TRPC: {
    name: 'tRPC',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  REACT_QUERY: {
    name: 'React Query',
    colorClass: 'bg-rose-100 dark:bg-rose-900 text-rose-800 dark:text-rose-100',
  },
  SWR: {
    name: 'SWR',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },
  APOLLO: {
    name: 'Apollo',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  FETCH: {
    name: 'Fetch API',
    colorClass:
      'bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-100',
  },
  AXIOS: {
    name: 'Axios',
    colorClass:
      'bg-violet-100 dark:bg-violet-900 text-violet-800 dark:text-violet-100',
  },
  // iOS Technologies
  SWIFT: {
    name: 'Swift',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  SWIFTUI: {
    name: 'SwiftUI',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  SWIFTDATA: {
    name: 'SwiftData',
    colorClass:
      'bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-100',
  },
  COMBINE: {
    name: 'Combine',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  CORE_DATA: {
    name: 'Core Data',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  UIKIT: {
    name: 'UIKit',
    colorClass: 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100',
  },
  CORE_ML: {
    name: 'Core ML',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  METAL: {
    name: 'Metal',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },

  // Android Technologies
  KOTLIN: {
    name: 'Kotlin',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  JETPACK_COMPOSE: {
    name: 'Jetpack Compose',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  ROOM: {
    name: 'Room',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  HILT: {
    name: 'Hilt',
    colorClass: 'bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-100',
  },
  COROUTINES: {
    name: 'Coroutines',
    colorClass: 'bg-pink-100 dark:bg-pink-900 text-pink-800 dark:text-pink-100',
  },
  FLOW: {
    name: 'Flow',
    colorClass:
      'bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-100',
  },
  ANDROID_JETPACK: {
    name: 'Android Jetpack',
    colorClass:
      'bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-100',
  },
  SPLASH_SCREEN: {
    name: 'Splash Screen',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  DIALOG_CORE: {
    name: 'Dialog Core',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },
  CALENDAR: {
    name: 'Calendar',
    colorClass:
      'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100',
  },
  COIL: {
    name: 'Coil',
    colorClass: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  },
  MATERIAL3: {
    name: 'Material 3',
    colorClass:
      'bg-violet-100 dark:bg-violet-900 text-violet-800 dark:text-violet-100',
  },
  PAGING3: {
    name: 'Paging 3',
    colorClass: 'bg-rose-100 dark:bg-rose-900 text-rose-800 dark:text-rose-100',
  },
  CLEANARCHITECTURE: {
    name: 'Clean Architecture',
    colorClass:
      'bg-amber-100 dark:bg-amber-900 text-amber-800 dark:text-amber-100',
  },
  RETROFIT: {
    name: 'Retrofit',
    colorClass: 'bg-lime-100 dark:bg-lime-900 text-lime-800 dark:text-lime-100',
  },
  NAVIGATION: {
    name: 'Navigation',
    colorClass: 'bg-sky-100 dark:bg-sky-900 text-sky-800 dark:text-sky-100',
  },

  // Cross-Platform Technologies
  REACT_NATIVE: {
    name: 'React Native',
    colorClass: 'bg-sky-100 dark:bg-sky-900 text-sky-800 dark:text-sky-100',
  },
  FLUTTER: {
    name: 'Flutter',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  EXPO: {
    name: 'Expo',
    colorClass:
      'bg-slate-100 dark:bg-slate-900 text-slate-800 dark:text-slate-100',
  },
  LOTTIE: {
    name: 'Lottie',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  DATA_PICKER: {
    name: 'Data Pucker',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  VECTOR_ICONS: {
    name: 'Vector Icons',
    colorClass: 'bg-pink-100 dark:bg-pink-900 text-pink-800 dark:text-pink-100',
  },

  // State Management
  REDUX: {
    name: 'Redux',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  BLOC: {
    name: 'Bloc',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  CONTEXTAPI: {
    name: 'ContaxtAPI',
    colorClass: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  },
  MOBX: {
    name: 'MobX',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  RECOIL: {
    name: 'Recoil',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  RIVERPOD: {
    name: 'Riverpod',
    colorClass: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  },

  // Backend & APIs
  NODEJS: {
    name: 'Node.js',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  EXPRESS: {
    name: 'Express',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },
  GRAPHQL: {
    name: 'GraphQL',
    colorClass: 'bg-pink-100 dark:bg-pink-900 text-pink-800 dark:text-pink-100',
  },
  REST_API: {
    name: 'REST API',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },

  // Databases & Storage
  FIREBASE: {
    name: 'Firebase',
    colorClass:
      'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100',
  },
  REALM: {
    name: 'Realm',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  SQLITE: {
    name: 'SQLite',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  MONGODB: {
    name: 'MongoDB',
    colorClass:
      'bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-100',
  },
  POSTGRESQL: {
    name: 'PostgreSQL',
    colorClass:
      'bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-100',
  },
  MYSQL: {
    name: 'MySQL',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  REDIS: {
    name: 'Redis',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },
  SUPABASE: {
    name: 'Supabase',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  DYNAMODB: {
    name: 'DynamoDB',
    colorClass: 'bg-sky-100 dark:bg-sky-900 text-sky-800 dark:text-sky-100',
  },
  PRISMA: {
    name: 'Prisma',
    colorClass:
      'bg-violet-100 dark:bg-violet-900 text-violet-800 dark:text-violet-100',
  },

  // Testing
  JEST: {
    name: 'Jest',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },
  TESTING_LIBRARY: {
    name: 'Testing Library',
    colorClass: 'bg-rose-100 dark:bg-rose-900 text-rose-800 dark:text-rose-100',
  },
  DETOX: {
    name: 'Detox',
    colorClass:
      'bg-violet-100 dark:bg-violet-900 text-violet-800 dark:text-violet-100',
  },
  XCTEST: {
    name: 'XCTest',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },

  // CI/CD & Development Tools
  FASTLANE: {
    name: 'Fastlane',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  GITHUB_ACTIONS: {
    name: 'GitHub Actions',
    colorClass: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100',
  },
  XCODE: {
    name: 'Xcode',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  ANDROID_STUDIO: {
    name: 'Android Studio',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },

  // Analytics & Monitoring
  MIXPANEL: {
    name: 'Mixpanel',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  GOOGLE_ANALYTICS: {
    name: 'Google Analytics',
    colorClass:
      'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100',
  },
  SENTRY: {
    name: 'Sentry',
    colorClass: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  },
  CRASHLYTICS: {
    name: 'Crashlytics',
    colorClass: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100',
  },

  // Authentication & Security
  AUTH0: {
    name: 'Auth0',
    colorClass:
      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-100',
  },
  OAUTH: {
    name: 'OAuth',
    colorClass:
      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100',
  },
  JWT: {
    name: 'JWT',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
  Inprogress: {
    name: 'Inprogress',
    colorClass:
      'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  },
} as const;
